import type { Module, ModuleOptions } from "src/system/module.types.ts";
import { mergeDeep } from "@exonn/utils";
import { createModuleI18nNamespaces } from "src/system/createModuleI18nNamespaces.ts";

export const getModule = (id: string): Module => {
  const modules = import.meta.glob<
    true,
    any,
    {
      module: ModuleOptions;
    }
  >("../admin/modules/**/module.tsx", {
    eager: true,
  });
  const module = modules[`../admin/modules/${id}/module.tsx`]?.module;
  if (!module) {
    throw new Error(`module for [${id}] id not found `);
  }

  const ns = createModuleI18nNamespaces();

  const defaults: Omit<Module, "resource" | "bigIcon" | "smallIcon"> = {
    name: (t) =>
      t("moduleName", {
        ns: ns.layout(module.resource),
      }),
    tabs: {
      edit: {
        titleProp: "title",
      },
    },
  };

  return mergeDeep(defaults, module);
};
